import * as React from 'react'
import {useAppContextState} from "app/@hooks";
import {createContext} from "use-context-selector";

const Context = createContext({})

const readIdReportExecutionFromUrl = () => {
	const v = new URLSearchParams(window.location.search).get('id_report_execution')
	return v ? Number(v) : null
}

export function CompetitionAnalyzerReportExecutionProvider({children}) {
	const { state, updateState, resetState } = useAppContextState({ idReportExecution: readIdReportExecutionFromUrl(), weekdays: null })

	return <Context.Provider value={{state, updateState, resetState}}>
		{children}
	</Context.Provider>
}

export default Context
